"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CalendarAddSmallFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_CalendarAddSmallFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1.875h4V3.5a1 1 0 1 0 2 0V1.904c.588.036 1.006.116 1.362.298a3 3 0 0 1 .756.548h.007v.007a3 3 0 0 1 .548.756c.194.381.273.832.305 1.487H1.022c.032-.655.11-1.106.305-1.487a3 3 0 0 1 .548-.756V2.75h.007a3 3 0 0 1 .756-.548c.356-.182.774-.262 1.362-.298V3.5a1 1 0 0 0 2 0V1.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.001 6 1 6.675V10.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 .548.756v.007h.007a3 3 0 0 0 .756.548C3.28 15 4.12 15 5.8 15h4.4c1.68 0 2.52 0 3.162-.327.28-.143.535-.328.756-.548h.007v-.007c.22-.22.405-.475.548-.756C15 12.72 15 11.88 15 10.2V6.675L14.999 6H1.001ZM8.5 7.5a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 1 0ZM5.5 1.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_CalendarAddSmallFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = CalendarAddSmallFill;
exports["default"] = _default;